// @flow

import * as React from "react";
import { Component } from "react";
import Intercom from "react-intercom";
import { Route, Switch, withRouter } from "react-router-dom";
import ReactGA from "react-ga";

import WithTracker from "../WithTracker/WithTracker";
import Header from "../Header/Header";
import Home from "../../pages/Home/Home";
import LinkedSession from "../../pages/LinkedSession/LinkedSession";
import LoginUser from "../../pages/LoginUser/LoginUser";
import NotFound from "../../pages/NotFound/NotFound";
import Project from "../../pages/Project/Project";
import Projects from "../../pages/Projects/Projects";
import Results from "../../pages/Results/Results";
import PublicHeader from "../PublicHeader/PublicHeader";
import Questions from "../../pages/Questions/Questions";
import SignupUser from "../../pages/SignupUser/SignupUser";
import UserInfo from "../../pages/UserInfo/UserInfo";
import WithLoadingIndicator from "../../components/WithLoadingIndicator/WithLoadingIndicator";
import { withUser } from "../../data/accounts";
import type { userQueryResult } from "../../data/accounts";

import { isMobile } from "../../utils/browser";

import "./App.css";

type Props = userQueryResult;

type State = {
  specialHeader: ?React.Node
};

class App extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      specialHeader: null
    };
    ReactGA.initialize("UA-111362159-2", {
      debug: process.env.NODE_ENV !== "production"
    });
  }

  setSpecialHeader = (specialHeader: React.Node) => {
    this.setState({ specialHeader });
  };

  unsetSpecialHeader = () => {
    this.setState({ specialHeader: null });
  };

  render() {
    if (isMobile()) {
      return (
        <div className="Mobile-Content">
          <p>
            {" "}
            Thanks for checking out ThinkAgain on your mobile device.
            ThinkAgain's challenges require at least a laptop-sized screen.
            Please visit us on your computer at thinkagain.ought.org
          </p>
          <ReactGA.OutboundLink eventLabel="Ought" to="https://ought.org">
            About Ought
          </ReactGA.OutboundLink>
        </div>
      );
    }
    return (
      <div className="App">
        <Header>
          {this.state.specialHeader || (
            <PublicHeader userData={this.props.userData} />
          )}
        </Header>
        <div className="App-Content">
          <Switch>
            <Route
              exact
              path="/"
              render={() => <Home userData={this.props.userData} />}
            />
            <Route exact path="/projects" render={() => <Projects />} />
            <Route
              exact
              path="/projects/:id"
              render={({ match }) => (
                <Project
                  projectId={match.params.id}
                  userData={this.props.userData}
                />
              )}
            />
            <Route
              exact
              path="/projects/:projectId/questions"
              render={({ match }) => (
                <Questions
                  projectId={match.params.projectId}
                  userData={this.props.userData}
                  setHeader={this.setSpecialHeader}
                  unsetHeader={this.unsetSpecialHeader}
                />
              )}
            />
            <Route
              exact
              path="/results"
              render={() => <Results userData={this.props.userData} />}
            />
            <Route
              exact
              path="/login"
              render={() => <LoginUser authType="login" />}
            />
            <Route
              exact
              path="/signup"
              render={() => (
                <SignupUser authType="signup" userData={this.props.userData} />
              )}
            />
            <Route
              exact
              path="/profile"
              render={() => <UserInfo userData={this.props.userData} />}
            />
            <Route
              exact
              path="/linked/:secret/:projectId/:limitKind/:limitValue/:assignmentId/:basePayCents/:maxBonusCents"
              render={({ match }) => (
                <LinkedSession
                  secret={match.params.secret}
                  projectId={match.params.projectId}
                  limitKind={match.params.limitKind}
                  limitValue={parseInt(match.params.limitValue, 10)}
                  assignmentId={match.params.assignmentId}
                  basePayCents={parseInt(match.params.basePayCents, 10)}
                  maxBonusCents={parseInt(match.params.maxBonusCents, 10)}
                  setHeader={this.setSpecialHeader}
                />
              )}
            />
            <Route component={WithTracker(NotFound)} />
          </Switch>
          <Intercom
            appID="h51geu59"
            {...(this.props.userData && this.props.userData.user) || {
              loggedIn: false
            }}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(withUser(WithLoadingIndicator(App)));



// WEBPACK FOOTER //
// ./src/components/App/App.js